<template>
  <div>
    <v-centerForm>
      <template slot='left'>
        <el-form inline :model="searchForm" ref="searchForm" label-width="100px">
          <el-form-item label="规则名称" prop="ruleName">
            <el-input placeholder="请输入规则名称" v-model="searchForm.ruleName" clearable></el-input>
          </el-form-item>
          <el-form-item label="风险等级" prop="riskLevel">
            <el-select v-model="searchForm.riskLevel" placeholder="请选择风险等级" clearable>
              <el-option label="低" value="low"></el-option>
              <el-option label="中" value="medium"></el-option>
              <el-option label="高" value="high"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理状态" prop="status">
            <el-select v-model="searchForm.status" placeholder="请选择处理状态" clearable>
              <el-option label="待处理" value="pending"></el-option>
              <el-option label="已处理" value="processed"></el-option>
              <el-option label="已忽略" value="ignored"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="触发时间">
            <el-date-picker
              v-model="searchForm.triggerTimeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
            <el-button icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template slot='right'>
        <el-button icon="el-icon-refresh" @click="refresh">刷新</el-button>
      </template>
    </v-centerForm>

    <v-tableEncapsulation
      :loading="loadingBtn.tableLoading"
      :columnData="columnData"
      :tableSize="pagination.size"
      :tableData="tableData"
      :tableTotal="pagination.total"
      :currentPage="pagination.current"
      @currentPage="handleCurrentChange"
      @sizeChange="handleSizeChange">
      <el-table-column slot="riskLevel" label="风险等级" align="center" width="100px">
        <template slot-scope="scope">
          <el-tag :type="getRiskLevelTagType(scope.row.riskLevel)" effect="dark">
            {{ scope.row.riskLevelText }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column slot="status" label="处理状态" align="center" width="100px">
        <template slot-scope="scope">
          <el-tag :type="getStatusTagType(scope.row.status)" effect="dark">
            {{ scope.row.statusText }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column slot="operate" label="操作" align="center" width="100px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="viewDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </v-tableEncapsulation>

    <!-- 详情弹窗 -->
    <el-dialog title="异常检测详情" :visible.sync="detailDialogVisible" width="800px">
      <el-descriptions :column="2" border v-if="anomalyDetail.id">
        <el-descriptions-item label="规则编码">{{ anomalyDetail.ruleCode }}</el-descriptions-item>
        <el-descriptions-item label="规则名称">{{ anomalyDetail.ruleName }}</el-descriptions-item>
        <el-descriptions-item label="风险等级">
          <el-tag :type="getRiskLevelTagType(anomalyDetail.riskLevel)" effect="dark">
            {{ anomalyDetail.riskLevelText }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="检测条件">{{ anomalyDetail.condition }}</el-descriptions-item>
        <el-descriptions-item label="处理方式">{{ anomalyDetail.handle }}</el-descriptions-item>
        <el-descriptions-item label="触发时间">{{ anomalyDetail.triggerTime }}</el-descriptions-item>
        <el-descriptions-item label="触发次数">{{ anomalyDetail.triggerCount }}</el-descriptions-item>
        <el-descriptions-item label="关联订单号">{{ anomalyDetail.relatedOrderNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="关联会员ID">{{ anomalyDetail.relatedMemberId }}</el-descriptions-item>
        <el-descriptions-item label="关联IP">{{ anomalyDetail.relatedIp }}</el-descriptions-item>
        <el-descriptions-item label="描述" :span="2">{{ anomalyDetail.description }}</el-descriptions-item>
        <el-descriptions-item label="处理状态">
          <el-tag :type="getStatusTagType(anomalyDetail.status)" effect="dark">
            {{ anomalyDetail.statusText }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="处理人">{{ anomalyDetail.processor || '-' }}</el-descriptions-item>
        <el-descriptions-item label="处理时间">{{ anomalyDetail.processTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="详情" :span="2" v-if="anomalyDetail.detail">
          <div>
            <p>请求次数：{{ anomalyDetail.detail.requestCount }}</p>
            <p>时间范围：{{ anomalyDetail.detail.timeRange }}</p>
            <p>IP列表：{{ (anomalyDetail.detail && anomalyDetail.detail.ipList) && anomalyDetail.detail.ipList.join(', ') }}</p>
            <p>会员列表：{{ (anomalyDetail.detail && anomalyDetail.detail.memberList) && anomalyDetail.detail.memberList.join(', ') }}</p>
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import { queryAnomalyList, queryAnomalyDetail } from '@/api/risk/riskApi'

export default {
  name: 'anomalyList',

  data () {
    return {
      searchForm: {
        ruleName: null,
        riskLevel: null,
        status: null,
        triggerTimeRange: null
      },
      loadingBtn: {
        tableLoading: false
      },
      columnData: [
        {
          type: 'index',
          label: '序号',
          width: '60px'
        },
        {
          label: '规则编码',
          prop: 'ruleCode',
          width: '100px'
        },
        {
          label: '规则名称',
          prop: 'ruleName',
          width: '150px'
        },
        {
          slot: 'riskLevel'
        },
        {
          label: '检测条件',
          prop: 'condition',
          width: '200px'
        },
        {
          label: '处理方式',
          prop: 'handle',
          width: '150px'
        },
        {
          label: '触发时间',
          prop: 'triggerTime',
          width: '160px'
        },
        {
          label: '触发次数',
          prop: 'triggerCount',
          width: '100px'
        },
        {
          label: '关联订单号',
          prop: 'relatedOrderNo',
          width: '180px'
        },
        {
          label: '关联会员ID',
          prop: 'relatedMemberId',
          width: '120px'
        },
        {
          label: '关联IP',
          prop: 'relatedIp',
          width: '130px'
        },
        {
          slot: 'status'
        },
        {
          label: '处理人',
          prop: 'processor',
          width: '120px'
        },
        {
          label: '处理时间',
          prop: 'processTime',
          width: '160px'
        },
        {
          slot: 'operate'
        }
      ],
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      detailDialogVisible: false,
      anomalyDetail: {}
    }
  },

  methods: {
    // 搜索
    search () {
      this.pagination.current = 1
      this.getTableData()
    },

    // 重置搜索
    resetSearch () {
      this.$refs.searchForm.resetFields()
      this.searchForm.triggerTimeRange = null
      this.pagination.current = 1
      this.getTableData()
    },

    // 刷新
    refresh () {
      this.getTableData()
    },

    // 获取表格数据
    getTableData () {
      this.loadingBtn.tableLoading = true
      const params = {
        current: this.pagination.current,
        size: this.pagination.size,
        ...this.searchForm
      }

      // 处理日期范围
      if (params.triggerTimeRange && params.triggerTimeRange.length === 2) {
        params.triggerTimeStart = params.triggerTimeRange[0]
        params.triggerTimeEnd = params.triggerTimeRange[1]
      }
      delete params.triggerTimeRange

      // 移除空值
      Object.keys(params).forEach(key => {
        if (params[key] === null || params[key] === '' || params[key] === undefined) {
          delete params[key]
        }
      })

      queryAnomalyList(params).then(({ data, code }) => {
        if (code === this.$constant.SUCCESS) {
          this.tableData = data.records || []
          this.pagination.total = data.total || 0
        }
        this.loadingBtn.tableLoading = false
      }).catch(() => {
        this.loadingBtn.tableLoading = false
      })
    },

    // 页码变化
    handleCurrentChange (current) {
      this.pagination.current = current
      this.getTableData()
    },

    // 每页条数变化
    handleSizeChange (size) {
      this.pagination.size = size
      this.pagination.current = 1
      this.getTableData()
    },

    // 查看详情
    viewDetail (row) {
      queryAnomalyDetail(row.id).then(({ data, code }) => {
        if (code === this.$constant.SUCCESS) {
          this.anomalyDetail = data || {}
          this.detailDialogVisible = true
        }
      })
    },

    // 获取风险等级标签类型
    getRiskLevelTagType (level) {
      const levelMap = {
        low: 'info',
        medium: 'warning',
        high: 'danger'
      }
      return levelMap[level] || 'info'
    },

    // 获取状态标签类型
    getStatusTagType (status) {
      const statusMap = {
        pending: 'warning',
        processed: 'success',
        ignored: 'info'
      }
      return statusMap[status] || 'info'
    }
  },

  created () {
    this.getTableData()
  }
}
</script>

<style lang="scss" scoped>
</style>
